<!--
 * @Description: 
 * @Autor: txp
 * @Date: 2021-03-29 10:01:35
-->
<template>
  <div class="systemsetting">
     <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="ft20 D1D1D1">系统设置</span>
      </div>
      <div class="pd2030">
        <div>更改主题颜色</div>
          <div>
            <theme-picker @change="themeChange"/>
          </div>
      </div>
     </el-card>
  </div>
  
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'PageMain',
  data () {
    return {
    }
  },
  methods:{
    ...mapActions({
      changeSetting: 'changeSetting'
    }),

    /**
     * @description 主题色改变
     * @param { String } val 色值
     */
    themeChange (val) {
      let self = this
      self.changeSetting({
        key: 'theme',
        value: val
      })
    }
  },
  computed: {
    ...mapGetters({
      theme: 'theme'
    })
  }
}
</script>
<style lang="scss">
  .systemsetting{
      height: 100%;
    .el-card{
      height: 100%;
      .el-card__header {
        border-bottom: 0;
        padding: 20px 20px 0px 20px;
      }
      .clearfix {
            font-size: 16px;
      }
    }
  }
</style>
